import React from 'react';
import {
    Card,
    CardContent,
    Avatar,
    Typography,
    Box,
    alpha,
    useTheme,
} from '@mui/material';

/**
 * Generic wrapper card for recharts charts.
 *
 * Props
 *   title    – card heading
 *   icon     – MUI icon element shown in the avatar
 *   height   – pixel height of the chart area (default 300)
 *   children – the <ResponsiveContainer> / chart JSX
 */
const ChartCard = ({ title, icon, height = 300, children }) => {
    const theme = useTheme();

    return (
        <Card
            elevation={0}
            sx={{
                background: theme.palette.background.paper,
                borderRadius: '16px',
                border: `1px solid ${theme.palette.divider}`,
                height: '100%',
                boxShadow: '0 2px 10px rgba(0,0,0,0.02)',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <CardContent sx={{ p: 3, flex: 1, display: 'flex', flexDirection: 'column' }}>
                {/* Header row */}
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <Avatar
                        sx={{
                            bgcolor: alpha(theme.palette.primary.main, 0.1),
                            color: theme.palette.primary.main,
                            width: 36,
                            height: 36,
                            mr: 2,
                            borderRadius: '8px',
                        }}
                    >
                        {icon && React.cloneElement(icon, { sx: { fontSize: 20 } })}
                    </Avatar>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary', fontSize: '1rem' }}>
                        {title}
                    </Typography>
                </Box>

                {/* Chart area */}
                <Box sx={{ flex: 1, ...(height !== 'auto' && { minHeight: height }) }}>{children}</Box>
            </CardContent>
        </Card>
    );
};

export default ChartCard;
